import { Injectable } from '@angular/core';
import {HttpClient}from '@angular/common/http';
import { Observable } from 'rxjs';
import{Ba1110Class}from '../../Class/ba1110/ba1110-class'
import{Ba4010Class}from '../../Class/ba4010/ba4010-class'
import {environment} from '../../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class ba1110Service {

  baseUrl: string=environment.baseUrl + 'ba1110/';
  constructor(private http:HttpClient) { }

GetUserName():Observable<any>
{
  return this.http.get<any>(this.baseUrl+'GetUserName');
}




LoadControls():Observable<any>
{

  return this.http.get<any>(this.baseUrl+'LoadControls');
}
GetCommonControlNames(id):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'GetCommonControlNames/'+id);
}

GetControlNames():Observable<any>
{
  return this.http.get<any>(this.baseUrl+'GetControlNames');
}

//Load saved data in to find section
LoadFind():Observable<any>
{
  return this.http.get<any>(this.baseUrl+'LoadFind');
}



DoFind(ba1110Class:Ba1110Class):Observable<any>
{

  return this.http.post<any>(this.baseUrl+'doFind',ba1110Class);
}


LoadDefaultBranch(objBa4010ClassArray:Array<Ba4010Class>): Observable<any>
{


  return this.http.post<any>(this.baseUrl+'LoadDefaultBranch',objBa4010ClassArray);
}

//Add or Edit an entry
Create(user_class:Ba1110Class): Observable<any>
{

  return this.http.post<any>(this.baseUrl+'Create',user_class);
}
ChangePwd(user_class:Ba1110Class): Observable<any>
{

  return this.http.post<any>(this.baseUrl+'ChangePwd',user_class);
}
Delete(id):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'Delete/'+id);
}
GetRole(id):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'GetRole/'+id);
}

LoadBranch(id):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'LoadBranch/'+id);
}

LoadCompanyRole(id):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'LoadCompanyRole/'+id);
}
LoadEmployees(id):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'LoadEmployees/'+id);
}
LoadUserTable(UserDtlsId):Observable<any>
{
  return this.http.get<any>(this.baseUrl+'LoadUserTable/'+UserDtlsId);
}
LoadStudentPortalList():Observable<any>
{
  return this.http.get<any>(this.baseUrl+'LoadStudentPortalList');
}
}
